const topics = [
  { label: '繁花似锦', hot: true, count: '128万' },
  { label: '极速追击', hot: true, count: '96万' },
  { label: '长安锦绣', hot: true, count: '85万' },
  { label: '风味人间', hot: false, count: '73万' },
  { label: '都市情感', hot: false, count: '61万' },
  { label: '古装传奇', hot: true, count: '58万' },
  { label: '悬疑推理', hot: false, count: '52万' },
  { label: '美食纪实', hot: false, count: '47万' },
  { label: '动作大片', hot: true, count: '43万' },
  { label: '科幻巨制', hot: false, count: '39万' },
  { label: '青春校园', hot: false, count: '35万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              热门话题标签
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              看看大家都在追什么，找到你的下一部心头好
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topics.map((topic, idx) => (
              <div
                key={idx}
                className={`group inline-flex items-center gap-2 px-5 py-3 rounded-full border cursor-pointer transition-all duration-300 hover:-translate-y-0.5 ${
                  topic.hot
                    ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                    : 'bg-background-50 border-background-200/70 hover:bg-background-100'
                }`}
              >
                {topic.hot && (
                  <i className="ri-fire-fill text-primary-500 text-sm"></i>
                )}
                <span className={`text-sm font-medium whitespace-nowrap ${
                  topic.hot ? 'text-primary-700' : 'text-foreground-700'
                }`}>
                  #{topic.label}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  {topic.count}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}